import axios from "axios";
import { PROVIDERNODE_BASE_URL } from "../constant";
import { unauthorizedErrorToastEmitter } from "../../../helper/utils";
const hostname = PROVIDERNODE_BASE_URL;

export const getDoctorList = async (data) => {
    try {
      let config = {
        method: "post",
        url: `${hostname}/provider/doctorList`,
        headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
          accept: "application/json",
        },
        data: data,
      };
      let response = await axios(config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };


  export const getDoctorDetails = async (data) => {
    try {

      let config = {
        method: "post",
        url: `${hostname}/provider/getDoctorDetails`,
        headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
          accept: "application/json",
        },
        data: data,
      };
      let response = await axios(config);
      return response.data;
    } catch (err) {
      unauthorizedErrorToastEmitter(err);
      console.log(err);
    }
  };


  export const createOrUpdateDoctorDetails = async (data) => {
    try {
      let config = {
        method: "post",
        url: `${hostname}/provider/onboardDoctor`,
        headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
          accept: "application/json",
        },
        data: data,
      };
      let response = await axios(config);
      return response.data;
    } catch (err) {
      console.log(err);
      throw (err.message);
    }
  };

  export const updateDoctorStatus = async (data) => {
    try {
      let config = {
        method: "post",
        url: `${hostname}/provider/updateDoctorStatus`,
        headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
          accept: "application/json",
        },
        data: data,
      };
      let response = await axios(config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };

  export const getEntityRelationPropertyAPI =async (data) => {
    try {
      let config = {
        method: "post",
        url: `${hostname}/provider/entityRelationProperty`,
        headers: {
          accesstoken: JSON.parse(localStorage.getItem("access_token")),
          accept: "application/json",
        },
        data: data,
      };
      let response = await axios(config);
      return response.data;
    } catch (err) {
      console.log(err);
    }
  };